var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.218,
    height: 41.596,
    viewBox: "0 0 46.218 41.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-business-center",
    "data-name": "Icon material-business-center",
    d: "M21.487,34.542V32.231H5.334l-.023,9.244A4.606,4.606,0,0,0,9.933,46.1H42.285a4.606,4.606,0,0,0,4.622-4.622V32.231H30.731v2.311ZM44.6,13.744H35.329V9.122L30.708,4.5H21.464L16.842,9.122v4.622H7.622A4.635,4.635,0,0,0,3,18.365V25.3A4.606,4.606,0,0,0,7.622,29.92H21.487V25.3h9.244V29.92H44.6A4.635,4.635,0,0,0,49.218,25.3V18.365A4.635,4.635,0,0,0,44.6,13.744Zm-13.865,0H21.487V9.122h9.244Z",
    transform: "translate(-3 -4.5)",
    fill: "#e61f2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessCenter);
export default __webpack_public_path__ + "static/media/icon-business-center.150c0ff1.svg";
export { ForwardRef as ReactComponent };